<template>
  <v-container class="body">
    <v-flex style="width: 100%; height: 100%; flex: auto; flex-flow: column">
      <div class="bottom-side">
        <div style="padding-left: 2%; margin-bottom: 40px">
          <h3 class="ant-typography">
            Reporte de los registros administrativos
          </h3>
          <v-divider></v-divider>
        </div>
        <v-row style="margin-left: -10%">
          <v-list nav max-width="400px" width="25%">
            <v-autocomplete
              :menu-props="{ bottom: true, offsetY: true }"
              :items="organizationsList"
              v-model="orgSelected"
              label="Institución"
            ></v-autocomplete>
            <v-autocomplete
              class="identification-answer"
              :items="courtDrop"
              label="Corte"
              v-model="courtFilter"
            ></v-autocomplete>
            <v-autocomplete
              class="identification-answer"
              :items="domainDrop"
              label="Dominio"
              @change="updateSubdomain"
              v-model="domainFilter"
            ></v-autocomplete>
            <v-autocomplete
              class="identification-answer"
              :items="subdomainDrop"
              label="Sub-dominio"
              v-model="subdomainFilter"
            ></v-autocomplete>
            <v-autocomplete
              class="identification-answer"
              :items="sectorDrop"
              label="Sector"
              v-model="sectorFilter"
            ></v-autocomplete>
          </v-list>

          <v-divider vertical></v-divider>

          <v-col style="width: 75%">
            <v-col align="right" style="margin-top: -4%">
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar"
                single-line
                hide-details
                style="width: 30%"
              ></v-text-field>
            </v-col>
            <v-progress-circular
              indeterminate
              class="load-public"
              color="primary"
              v-if="loading"
            >
              Cargando
            </v-progress-circular>
            <v-data-table
              v-else
              ref="table"
              :headers="headers"
              :items="filteredItems"
              :items-per-page="5"
              :rows-per-page="20"
              :page="1"
              :loading="loading"
              :item-key="'code'"
              :search="search"
            >
              <template v-slot:item.date="{ item }">
                {{ filteredDate(item.date) }}</template
              >
              <template v-slot:item.controls="{ item }">
                <!-- stop prop prevent to trigget the click row event -->
                <v-icon small class="mr-2" @click.stop="viewPublicForm(item)"
                  >mdi-eye</v-icon
                >
                <v-icon small class="mr-2" @click.stop="downloadItem(item)"
                  >mdi-download</v-icon
                >
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </div>
    </v-flex>
  </v-container>
</template>

<script>
import {
  getAuxiliarByType,
  getAllPublicForm,
  getAuxiliarByTypeWithDependency,
  getCourts,
} from "@/utils/apiRequest";

export default {
  data() {
    return {
      usrn: "",
      pwd: "",
      unvalid: false,
      reload: false,
      download: false,
      formsCount: 0,
      ans: {},
      search: "",
      selectedItem: 0,
      domainFilter: "",
      sectorFilter: "",
      subdomainFilter: "",
      courtFilter: "",
      orgSelected: "",
      domainDrop: [""],
      courtDrop: [""],
      subdomainDrop: [""],
      organizationsList: [""],
      sectorDrop: [""],
      courts: [],
      loading: true,
      items: ["dominio", "sub-dominio", "sector"],
      counters: [{ dominio: 2, subdominio: 4, sector: 7 }],
      reportList: [],
      headers: [
        {
          text: "Número de formulario",
          value: "id",
        },
        { text: "Nombre del R.A", value: "name" },
        { text: "Institución", value: "organization" },
        { text: "Fecha de creación", value: "date" },
        { text: "Fecha de actualización", value: "updateDate" },
        { text: "", value: "controls", width: "10%" },
      ],
    };
  },
  methods: {
    filteredDate(dateString) {
      let date = new Date(dateString);
      return date.toLocaleString();
    },
    viewPublicForm(form) {
      try {
        const path = `/public/${form.id}`;
        window.open(path, "_blank");
      } catch (error) {
        console.log(error);
      }
    },
    async downloadItem(form) {
      try {
        const path = `/public/${form.id}#print`;
        window.open(path, "_blank");
      } catch (error) {
        console.log(error);
      }
    },
    async updateSubdomain(val) {
      let response = await getAuxiliarByTypeWithDependency(
        "Subdominio de la actividad estadística",
        val
      );
      if (response.data.status == "success") {
        let subdomains = [""];
        response.data.auxiliar.forEach((aux) => {
          subdomains.push(aux.value);
        });
        this.subdomainDrop = subdomains;
      }
    },
  },
  components: {},
  computed: {
    filteredItems() {
      return this.reportList.filter((item) => {
        let courtID = this.courts[this.courtFilter];
        if (courtID == undefined) {
          courtID = "";
        }

        item.fullText =
          item.name +
          item.id.toString() + // this could be a number, and if name is null, the whole text will be a num
          item.organization +
          item.domain +
          item.subdomain +
          item.court +
          item.sector;

        item.fullText = item.fullText.toLowerCase();

        let included =
          item.fullText.indexOf(this.search.toLowerCase()) > -1 &&
          item.fullText.indexOf(this.domainFilter.toLowerCase()) > -1 &&
          item.fullText.indexOf(this.subdomainFilter.toLowerCase()) > -1 &&
          item.fullText.indexOf(this.sectorFilter.toLowerCase()) > -1 &&
          item.fullText.indexOf(this.orgSelected.toLowerCase()) > -1 &&
          item.fullText.indexOf(courtID.toLowerCase()) > -1;
        return included;
      });
    },
  },
  async mounted() {
    let response = await getAuxiliarByType("Dominio actividad estadística");
    if (response.data) {
      if (response.data.status == "success") {
        response.data.auxiliar.forEach((aux) => {
          this.domainDrop.push(aux.value);
        });
      }
    }
    response = await getAuxiliarByType(
      "Subdominio de la actividad estadística"
    );
    if (response.data) {
      if (response.data.status == "success") {
        response.data.auxiliar.forEach((aux) => {
          this.subdomainDrop.push(aux.value);
        });
      }
    }
    response = await getAuxiliarByType("sector");
    if (response.data) {
      if (response.data.status == "success") {
        response.data.auxiliar.forEach((aux) => {
          this.sectorDrop.push(aux.value);
        });
      }
    }

    response = await getAllPublicForm();
    if (response.data) {
      if (response.data.status == "success") {
        this.reportList = response.data.forms;
      }
    }

    response = await getAuxiliarByType(
      "Nombre de la institución responsable del R.A"
    );
    if (response.data) {
      if (response.data.status == "success") {
        response.data.auxiliar.forEach((aux) => {
          this.organizationsList.push(aux.value);
        });
      }
    }

    this.domainDrop = this.domainDrop.sort();
    this.subdomainDrop = this.subdomainDrop.sort();
    this.sectorDrop = this.sectorDrop.sort();
    this.organizationsList = this.organizationsList.sort();
    response = await getCourts();

    if (response.data.status == "success") {
      this.courtFilter = response.data.cortes[0].name;
      
      response.data.cortes.forEach((court) => {
        this.courtDrop.push(court.name);
        this.courts[court.name] = court.id;
      });
    }

    this.loading = false;
  },
};
</script>

<style scoped>
.ant-image-img {
  width: 100%;
  height: 100%;
}

.ant-typography {
  color: rgba(0, 0, 0, 0.85);
  word-break: normal;
}

.ant-typography h3,
h3.ant-typography {
  margin-bottom: 0.5em;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600;
  font-size: 24px;
  line-height: 1.35;
}
.middle-line {
  height: 10px;
  background-color: rgb(177, 174, 174);
}

.right-text {
  margin-left: 10%;
}

.bottom-side {
  background-color: #f1f0ff;
  margin-top: 2%;
  padding: 40px 10%;
  margin-bottom: 40px;
  background: rgb(255, 255, 255);
}

.shield {
  width: 60px;
  height: 60px;
  margin-left: 1%;
}

.one-logo {
  width: 90px;
  height: 50px;
  margin-left: 20%;
}

.formsCountDiv {
  vertical-align: 50%;
}

.load-public {
  margin: 5% 0 0 50%;
}

.loading {
  position: absolute;
  left: 50%;
  margin: 25% 0 0 0;
}

.reports {
  margin: 5% 0 0 0 0;
  overflow-y: auto;
  max-height: 350px;
  width: 100%;
}

/* .flex {
  align-items: center;
  align-content: center;
  align-self: center;
} */
</style>